import { locale } from "./config";

export const formatCurrency = (numb) => {
  const number = numb * 1;
  let parts = number.toFixed(2).split(".");

  parts[0] = new Intl.NumberFormat(locale).format(parseInt(parts[0]));

  return `${parts[0]}.${parts[1]}`;
};

export const formartCurrencyUK = formatCurrency;
